import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-european-moldova',
  templateUrl: './european-moldova.component.html',
  styleUrls: ['./european-moldova.component.scss']
})
export class EuropeanMoldovaComponent implements OnInit, AfterViewInit {

  showMdUeCampaignMessage: boolean = true;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.showMdUeCampaignMessage) {
        this.fadeInMessage();
      }
    }, 2000);
  }

  onCircleClick(): void {
    if (this.showMdUeCampaignMessage) {
      this.showMdUeCampaignMessage = false;
      this.fadeOutMessage();
    }

    window.open('https://moldovaeuropeana.md/', '_blank');
  }

  onCloseButtonClick(): void {
    this.showMdUeCampaignMessage = false;
    this.fadeOutMessage();
  }

  private fadeInMessage(): void {
    const messageElement = document.getElementById('md-ue-campaign-message');
    if (messageElement) {
      messageElement.style.display = 'block';
      messageElement.style.opacity = '0';
      setTimeout(() => {
        messageElement.style.transition = 'opacity 0.25s';
        messageElement.style.opacity = '1';
      }, 10);
    }
  }

  private fadeOutMessage(): void {
    const messageElement = document.getElementById('md-ue-campaign-message');
    if (messageElement) {
      messageElement.style.transition = 'opacity 0.2s';
      messageElement.style.opacity = '0';
      setTimeout(() => {
        messageElement.style.display = 'none';
      }, 200);
    }
  }
}
